import { createAction } from 'redux-actions';
import api from '../../services/api';
import {
  SAVE_ABOUT,
  SAVE_ABOUT_SUCCESS,
  SAVE_ABOUT_FAILURE,
  ADD_ABOUT_TO_THE_LIST,
  UPDATE_ABOUT_IN_THE_LIST
} from './actionTypes';
import { change } from 'redux-form';

//<<<---SAVE-ABOUT--->>>
export const saveAboutInProgress = createAction(SAVE_ABOUT);
export const saveAboutSuccess = createAction(SAVE_ABOUT_SUCCESS);
export const addAboutToTheList = createAction(ADD_ABOUT_TO_THE_LIST);
export const saveAboutFailure = createAction(SAVE_ABOUT_FAILURE);

export const saveAbout = (formData, lang, callback) => async dispatch => {
  dispatch(saveAboutInProgress());
  try {
    const res = await api.post(`about/${lang}`, formData);
    const { data } = res;
    callback();
    dispatch(saveAboutSuccess(data));
    dispatch(addAboutToTheList(data));
  } catch (error) {
    dispatch(saveAboutFailure(error));
  }
};

//<<<---UPDATE-ABOUT--->>>
export const updateAboutInTheList = createAction(UPDATE_ABOUT_IN_THE_LIST);

export const updateAbout = (formData, id, lang, callback) => async dispatch => {
  dispatch(saveAboutInProgress());
  try {
    const res = await api.post(`about/${id}/${lang}`, formData, {
      headers: { 'X-HTTP-Method-Override': 'PUT' }
    });
    const { data } = res;
    callback();
    dispatch(saveAboutSuccess(data));
    dispatch(updateAboutInTheList(data));
  } catch (error) {
    dispatch(saveAboutFailure(error));
  }
};

export const setValueToEmptyObject = (formName, fieldName) => () =>
  change(formName, fieldName, {});



// WEBPACK FOOTER //
// ./src/modules/AboutForm/actions.js